/** Hook to load lightweight municipality marker points for the live map. */

import { useEffect, useState } from "react";

import { apiClient } from "../api/client";
import type { ApiError, GeoJSONFeatureCollection } from "../types";

const EMPTY_LOCATIONS: GeoJSONFeatureCollection = {
  type: "FeatureCollection",
  features: [],
};

interface UseGemeindeLocationsResult {
  municipalityLocations: GeoJSONFeatureCollection;
  loading: boolean;
  error: string | null;
}

export function useGemeindeLocations(): UseGemeindeLocationsResult {
  const [municipalityLocations, setMunicipalityLocations] =
    useState<GeoJSONFeatureCollection>(EMPTY_LOCATIONS);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    apiClient
      .getGemeindeLocations()
      .then((data) => {
        if (!cancelled) {
          setMunicipalityLocations(data);
          setError(null);
        }
      })
      .catch((err: ApiError | Error) => {
        if (!cancelled) setError(err.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { municipalityLocations, loading, error };
}
